import {Link, useNavigate} from 'react-router-dom';

export default function TimesheetWidget() {
    return (
        <div className="timesheet-widget">
            <div className="timesheet-widget-header">
                <p>Relevés d'heures</p>
                <h3>4 à compléter</h3>
            </div>
            <div className="timesheet-widget-content">
                <p>Prenez le temps de valider les relevés d’heures pour éviter les erreurs</p>
                <Link to={"/releve-heure"}>Valider les relevés d’heures <span className={"arrow"} /> </Link>
            </div>
        </div>
    );
}